import { useTranslation } from "react-i18next";
import { Currency } from "../i18n/Currency";
import { CurrencyTextField } from "./general/CurrencyTextField";
import { WeightedEstimate } from "./general/WeightedEstimates";

export type WeightedValueEditorProps = {
  value: number;
  currency: Currency;
  onValueChange: (newValue: number) => void;
  weight?: number;
  onWeightChange?: (newValue: number) => void;
  share?: number;
  onDelete?: () => void;
  min?: number;
  max?: number;
};

export const WeightedValueEditor = ({
  value,
  currency,
  weight,
  share,
  min,
  max,
  onValueChange,
  onWeightChange,
  onDelete,
}: WeightedValueEditorProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "weightedValue" });

  return (
    <WeightedEstimate
      kind="weightedValue"
      weight={weight}
      share={share}
      onWeightChange={onWeightChange}
      onDelete={onDelete}
    >
      <CurrencyTextField
        currency={currency}
        // the column is headed with what the field holds
        ariaLabel={t("label.value")}
        variant="outlined"
        size="small"
        value={value}
        onValueChange={(newValue) => {
          if (Number.isNaN(newValue)) onValueChange(0);
          if (newValue >= 0) onValueChange(newValue);
        }}
        min={min}
        max={max}
        sx={{ width: "100%" }}
      />
    </WeightedEstimate>
  );
};
